import { AccordionPanel, Flex, FormLabel, Text } from '@chakra-ui/react';
import { type FC } from 'react';

import { LoadingCheckbox } from '$/components/common/LoadingCheckbox';
import { type FilterOptionGroup } from '$/services/usecases/filter';
import { type SingleMaterialFilterOption } from '$/services/usecases/materials';
import { getCollectionStore } from '$/stores/useCollectionStore';

interface Props {
  filter: FilterOptionGroup;
  onToggle: (option: SingleMaterialFilterOption) => void;
  compactMode?: boolean;
}

export const AccordionContent: FC<Props> = ({
  filter,
  onToggle,
  compactMode = false,
}) => {
  return (
    <AccordionPanel px='0' pb={compactMode ? '0' : undefined}>
      {filter.items.map((item) => (
        <FormLabel
          key={item.value}
          alignItems='center'
          justifyContent='space-between'
          display='flex'
          m='0'
          px={compactMode ? '4' : '6'}
          pb={compactMode ? '1' : '2'}
          borderRadius='sm'
          _hover={{ backgroundColor: 'bodyBackground' }}
          cursor='pointer'
        >
          <Text
            maxW={compactMode ? '100px' : undefined}
            fontSize={compactMode ? 'xs' : 'sm'}
          >
            {item.displayName}
          </Text>

          <Flex align='center' gap='2'>
            <Text color='lighterText' fontSize={compactMode ? 'xss' : 'xs'}>
              {item.count}
            </Text>

            <LoadingCheckbox
              borderColor='text'
              isChecked={getCollectionStore().isFilterActive(
                filter.searchField,
                item.value,
              )}
              onChange={() =>
                onToggle({ option: filter.searchField, value: item.value })
              }
            />
          </Flex>
        </FormLabel>
      ))}
    </AccordionPanel>
  );
};
